module.exports = __webpack_public_path__ + "c494dbf395aa7c153586e43257125291.pdf";